export const DASHBOARD_API_URL = {
  GET_DASHBOARD_PAGING: 'dashboard/paging',
  GET_DASHBOARD_ID: 'dashboard',
  DELETE_DASHBOARD: 'dashboard/{{dashboard_id}}',
  CREATE_DASHBOARD: 'dashboard',
  UPDATE_DASHBOARD: 'dashboard',
  GET_ALL_DASHBOARD: 'dashboard/all',
  CREATE_DASHBOARD_WIDGET: 'dashboard-widget',
  GET_DASHBOARD_WIDGET_BY_ID: 'dashboard-widget/{{widget_id}}',
  UPDATE_DASHBOARD_WIDGET: 'dashboard-widget',
  DELETE_DASHBOARD_WIDGET: 'dashboard-widget/{{widget_id}}',
  UPDATE_WIDGET_SEQUENCE: 'dashboard-widget/sequence',
  REAL_TIME_STATUS: 'realtime-status',
  FRAUD_TRANSACTION: 'fraud',
  ARCHIVED_EMPLOYEES: 'archived-employees',
  WORKING_EMPLOYEES: 'working-employee',
  LATE_EMPLOYEES: 'late-employee',
  NOT_SCHEDULED_USERS: 'not-scheduled-users',
  REAL_TIME_MAP: 'Map-On-Shift',
  ON_LEAVE: 'on-leave',
  ON_BREAK: 'on-break',
  UNAVAILABLE_EMPLOYEE: 'unavailable-employee',
  SCHEDULE_TIMESHEET_COST: 'schedule-timesheet-cost',
  SCHEDULE_TIMESHEET_HOURS: 'schedule-timesheet-hours',
  QR_CODE_TRANSACTIONS: 'qr-code-transactions',
  ON_LOOP: 'on-loop',
  LOOP_CHECK_IN: 'loop-check-in',
  LOOP_HISTORY: 'loop-history',
  UPCOMING_SHIFT: 'upcoming-shifts',
  EMPLOYEE_POINTS: 'employee-points',
  UNASSIGNED_EMPLOYEE: 'unassigned-employee',
  MASTER_WIDGET_ALL_ACTIVE: 'master-widget/all-active',
  DEFAULT_BUSINESS: 'dashboard/set-default',
  UNARCHIVE_DASHBOARD: 'dashboard/unarchive'
};
